import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const drinksApi = {
  getDrinks: async (params?: any) => {
    const response = await axios.get(`${API_URL}/api/admin/drinks`, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },

  getDrinkById: async (id: string) => {
    const response = await axios.get(`${API_URL}/api/admin/drinks/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },

  createDrink: async (data: any) => {
    const response = await axios.post(`${API_URL}/api/admin/drinks`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },

  updateDrink: async (id: string, data: any) => {
    const response = await axios.put(`${API_URL}/api/admin/drinks/${id}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },

  toggleDrink: async (id: string) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/drinks/${id}/toggle`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  deleteDrink: async (id: string) => {
    const response = await axios.delete(`${API_URL}/api/admin/drinks/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },
};

export default drinksApi;
